export const GET_REQUEST_PASSWORD_REQUEST = "GET_REQUEST_PASSWORD_REQUEST";
export const GET_REQUEST_PASSWORD_SUCCESS = "GET_REQUEST_PASSWORD_SUCCESS";
export const GET_REQUEST_PASSWORD_FAILURE = "GET_REQUEST_PASSWORD_FAILURE";

export const UPDATE_PASSWORD_REQUEST = "UPDATE_PASSWORD_REQUEST";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAILURE = "UPDATE_PASSWORD_FAILURE";
